import { render, staticRenderFns } from "./PaySuccessShorexBottom.vue?vue&type=template&id=0756f9b4&scoped=true"
import script from "./PaySuccessShorexBottom.vue?vue&type=script&lang=js"
export * from "./PaySuccessShorexBottom.vue?vue&type=script&lang=js"
import style0 from "./PaySuccessShorexBottom.vue?vue&type=style&index=0&id=0756f9b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756f9b4",
  null
  
)

export default component.exports